module.exports = __webpack_public_path__ + "img/tomcat.598f5953.webp";